module.exports = __webpack_public_path__ + "img/aboutus.65a87bfd.png";